export const isPercy = process.env.NODE_ENV === 'PERCY'
